<div class="dashboard-day-filter {{class}}" [class.dashboard-day-filter-sm]="sm">
  <label [for]="id">{{weekdayLabel}}</label>
  <div class="date-field">
    <input
      type="text"
      autocomplete="off"
      class="form-control"
      [id]="id"
      [disabled]="disabled"
      [maxlength]="10"
      [ngClass]="{'is-invalid': !dateIsValid(), 'ng-valid': dateIsValid()}"
      [placeholder]="'datetime.date'|translate"
      [(ngModel)]="filterDate"
      (ngModelChange)="dateChange()"
      ngbDatepicker
      [minDate]="minDate"
      [maxDate]="maxDate"
      #datePicker="ngbDatepicker">
    <button
      type="button"
      tabindex="-1"
      class="btn btn-light"
      [disabled]="disabled"
      (click)="datePicker.toggle()">
      <i class="fa fa-calendar"></i>
    </button>
  </div>

  <span *ngIf="dayLabelTranslation" class="day-label">
    ({{dayLabelTranslation|translate}})
  </span>
</div>
